export default __webpack_public_path__ + "fonts/ionicons.0b4ad6170d93c4aa91eec612b747eb0f.woff";